goog.provide('el8.apphome.docMgr.Filer');

goog.require('el8.app.shared.dialog.filerFields');
goog.require('el8.apphome.docMgr.renderer');
goog.require('el8.apphome.docMgr.util');
goog.require('el8.appshared.dialog.createPatient');
goog.require('el8.appshared.dialog.discreteLabFields');
goog.require('el8.appshared.mindreaderOpts');
goog.require('el8.data.labTestVendors');
goog.require('el8.data.practiceUsers');
goog.require('el8.practicedata.uploadedImages');
goog.require('el8.service.intervals');
goog.require('el8.service.tz');
goog.require('el8.template.render.docMgr.filer');
goog.require('el8.uiwidget.ButtonSet');
goog.require('el8.uiwidget.Form');
goog.require('el8.uiwidget.NewActionsMenu');
goog.require('el8.util.string');
goog.require('el8.util.validate');
goog.require('el8.util.amplitude.helpers');
goog.require('el8.util.amplitude.documentHelpers');


el8.apphome.docMgr.Filer = function(spec) {

    this._container = spec.container;
    this._dialogContainer = spec.dialogContainer;
    this._panel = spec.panel;

    this._IMAGE_WIDTH = 960;
    this._IMAGE_HEIGHT = 1242;

    this._showOrganizerFn = spec.showOrganizerFn;
    this._fileCallbackFn = spec.fileCallbackFn;
    this._getFileIds = spec.getFileIds;
    this._updatePreviewedFn = spec.updatePreviewedFn;

    // These are objects like {'name': 'Lab Report', 'value': 'LabReport'} i.e. the value
    // is the report_type with 'Report' appended which is the value in the dropdown
    this._documentTypes = [];

    // FUTURE: Store the current patient here. Refactor selectedPatient to use this... actually
    // refactor this whole form (and the entire UX flow)...
    this._patient = null;
};

el8.apphome.docMgr.Filer.prototype._init = function() {
    if (this._isInit) { return; }
    this._isInit = true;
    this._container.append(el8.template.render.docMgr.filer.content());
    this._imageLoader = new el8.apphome.docMgr.ImageLoader({
        initialSize: 2,
        container: $('#filer-preview-content', this._container),
        scrollContainer: $('.filer-container', this._container),
        width: this._IMAGE_WIDTH, // gets readjusted in _adjustSize
        height: this._IMAGE_HEIGHT, // gets readjusted in _adjustSize
        imageClass: 'preview',
        imageWrapSelector: '.image-item-wrap',
        selector: 'li.preview-item',
        rendererFn: el8.apphome.docMgr.renderer.filer,
        itemIdFn: function(item) { return 'filer-'+item.getFeedItemId(); }
    });
    this._bindRenderTriggers();
    this._bindFormTriggers();

    var that = this;
    this._panel.bind('el8_adjustSize', function() {
        that._adjustSize();
    });

    this._initPreviewSection();
    this._loadFormMetadata(function() {
        that._initAssignmentForm();
        that._updateFormsForPatient();
    });
};

el8.apphome.docMgr.Filer.prototype.show = function(itemIds) {
    if (!this._isInit) { this._init(); }
    this._hideForm();
    this._adjustSize(); // come first
    if (itemIds) {
        this._renderPreviewSection(itemIds);
        this._showForm();
    }
};

el8.apphome.docMgr.Filer.prototype.hide = function() {
    this._hideUnknownPatient();
    this._hideForm();
};

el8.apphome.docMgr.Filer.prototype._adjustSize = function() {
    var tabbedNavHeight = $('.tabbed-nav', this._dialogContainer).outerHeight(true) || 0;

    var height = $('.filer-content', this._dialogContainer).height() - tabbedNavHeight;
    $('.filer-container', this._container).height(height)
        .css('top', tabbedNavHeight);
     //let the lab form get big but never so big it eliminates horizontal reading space
    var $labFormWrapper = $('#filer-lab-form-wrapper', this._container);
    var labHeight = Math.max(Math.floor(height * 2/3), 300);
    $labFormWrapper.css('height', labHeight);
    $('#filer-lab-form', this._container).css('height', labHeight);

    // same for the quickadd form. subtracting the 32 instead of 83 because
    $('#filer-quickadd-form', this._container).css('height', labHeight);
};

/**
 *  Filer preview rendering
 */
el8.apphome.docMgr.Filer.prototype._bindRenderTriggers = function() {
    var that = this;
    this._container.on('click', '.actions-trigger',  function(e) {
        var id = $(this).attr('data-id')*1;
        var menu = [
            {
                actionText: 'Rotate Left',
                actionFn: function() { that._rotateImage('left', id); }
            },
            {
                actionText: 'Rotate 180',
                actionFn: function() { that._rotateImage('180', id); }
            },
            {
                actionText: 'Rotate Right',
                actionFn: function() { that._rotateImage('right', id); }
            }
        ];
        that._actionsMenu.display($(this), null, {'top': 20, 'left': 20}, menu, 2);
        return false;
    });
};
el8.apphome.docMgr.Filer.prototype.scrollToPreviewItem = function(id) {
    var $content = $('#filer-preview-content', this._container).closest('.filer-container');
    $content.scrollTo(
        $('.preview-item[data-id="'+id+'"]', this._container),
        {duration: 600, offset: {top: -20}}
    );
};
el8.apphome.docMgr.Filer.prototype.removeItem = function(id) {
    var that = this;
    this._imageLoader.removeItem(id, function() {
        if (!that._imageLoader.hasItems()) {
            that._showOrganizerFn();
        }
    });
};
el8.apphome.docMgr.Filer.prototype._rotateImage = function(direction, itemId) {
    el8.appservice.notifier.notify('Rotating image ' + direction + '...');
    el8.practicedata.uploadedImages.rotateImage({
        id: itemId,
        direction: direction,
        size: 'filer',
        successCb: function() {
            el8.appservice.notifier.notify('Image rotated');
            el8.practicedata.uploadedImages.realtimeNotify(itemId, 'UPDATED_IMAGE');
        }
    });
};
el8.apphome.docMgr.Filer.prototype.refreshImage = function(itemId) {
    this._imageLoader.refreshImage(itemId);
};
el8.apphome.docMgr.Filer.prototype._initPreviewSection = function() {
    var $filerSection = $('.filer-container', this._container);
    this._actionsMenu = new el8.uiwidget.NewActionsMenu({
        container: $filerSection,
        anchorTop: $('#filer-preview-content', this._container),
        menuId: 'filer-actions-menu'
    });
    var that = this;
    var scrollTimeout = null;
    $filerSection.on('scroll', function(e) {
        if (scrollTimeout) {
            $.el8_clearTimeout(scrollTimeout);
        }
        scrollTimeout = $.el8_setTimeout(function() {
            var listTop = $filerSection.offset().top;
            var listBottom = listTop + $filerSection.height();
            $('.preview-item', that._container).each(function(index, elt) {
                if (el8.apphome.docMgr.util.isInView($(elt), listTop, listBottom)) {
                    that._updatePreviewElt($(elt));
                    return false;
                }
            });
        }, 250);
    });
};
el8.apphome.docMgr.Filer.prototype._renderPreviewSection = function(itemIds) {
    var items = itemIds.map(function(id) {
        return el8.practicedata.getUploadedFileOrImage(id);
    });
    this._imageLoader.show(items);
    this._currPreviewElt = this._imageLoader.getNthElt(0);
};
el8.apphome.docMgr.Filer.prototype._updatePreviewElt = function($elt) {
    this._currPreviewElt = $elt;
    var id = $elt.attr('data-id');
    this._updatePreviewedFn(id);
};
el8.apphome.docMgr.Filer.prototype.updatePreviewImages = function() {
    var ids = this._getFileIds();  // according to thumbnails
    if (ids.length !== $('.preview-item', this._container).length) { return; } // Problem!
    for (var i=0; i<ids.length; i++) {
        var $candidate = $('.preview-item', this._container).eq(i);
        var previewItemId = $candidate.attr('data-id')*1;
        if (previewItemId !== ids[i]) {
            var $target = $('.preview-item[data-id="'+ids[i]+'"]', this._container).detach();
            $candidate.after($target);
        }
    }
};

/**
 * All the form related methods
 */
el8.apphome.docMgr.Filer.prototype._loadFormMetadata = function(callbackFn) {
    var that = this;
    el8.data.labTestVendors.softLoad(null, false); //required to render the lab form so make it synchronous
    $.el8_ajax({
        type: 'GET',
        url: el8.service.urls.get('fileFormMetadata'),
        success: function(data) {
            that._documentTypes = data['available_document_types'];
            if (callbackFn) { callbackFn(); }
        }
    });
};

el8.apphome.docMgr.Filer.prototype._showForm = function() {
    $('#filer-form-content', this._container).show();
    this._form.initFocus();
};

el8.apphome.docMgr.Filer.prototype._hideForm = function() {
    $('#filer-form-content', this._container).hide();
};

el8.apphome.docMgr.Filer.prototype._initAssignmentForm = function() {
    var $content = $('#filer-form-content', this._container);
    $content.html(
        el8.template.render.docMgr.filer.docMgrForm({
            documentTypes: this._documentTypes,
            vendorChoices: el8.data.labTestVendors.allAsSoyMaps()
        })
    );

    var that = this;
    var patientMindreaderOpts = el8.appshared.mindreaderOpts.enterpriseAwarePatient({
        selectFn: function(event, item) {
            that._hideUnknownPatient();
            if (item.primaryPhysicianUserId) {
                var user = el8.data.practiceUsers.getById(item.primaryPhysicianUserId);
                that._form.setMindreaderItem('physicianUserName', user.asSoyMap());
            }
        },
        createNewCallbackFn: function(data) {
            that._createNewPatientFn(data);
        },
        location: 'doc-mgr'
    });
    patientMindreaderOpts.containerHeight = 171;
    patientMindreaderOpts.containerLeftOffset = -291;

    var that = this;
    var fields = [
        {
            name: 'patientName',
            selector: ':input[name="patientName"]',
            infoText: 'patient name...',
            height: 16,
            validate: {required: true},
            newMindreader: true,
            mindreaderOpts: patientMindreaderOpts,
            blurFn: function(e, _form) {
                if (!that._form.getMindreaderItem('patientName') &&
                      that._form.getVal('patientName')) {
                    that._showUnknownPatient();
                } else {
                    that._hideUnknownPatient();
                }
            },
            changeFn: function(e, _form) {
                var selectedPatient = that._form.getMindreaderItem('patientName');
                that._updateFormsForPatient(selectedPatient);
                that._patient = selectedPatient;
            }
        }
    ];
    fields = fields.concat(
        el8.app.shared.dialog.filerFields.getSharedFields(true, function() { return that._form; })
    );

    this._form = new el8.uiwidget.Form({
        container: $('#filer-form', $content),
        buttonElt: $('.button-list', $content),
        fields: fields,
        validationOpts: el8.util.validate.standardOpts
    });
      //the discrete labs form gets its own Form object so it can be reset / validated / mapped separately
    this._labForm = new el8.uiwidget.Form({
        container: $('#filer-lab-form', $content),
        fields: el8.appshared.dialog.discreteLabFields.getFields(true)
    });
    el8.appshared.dialog.discreteLabFields.init({ //placed here so that _labForm is already initialized
        container: this._container,
        form: this._labForm
    });

    this._form.addButton('file', 'File into Chart', function(_form) {
        that._fileIntoChart();
    }, true);
    this._form.addButton('clear', 'Clear Form', function(_form) {
        that._resetForms();
        _form.initFocus();
    }, false);
    this._labForm.render();
    this._form.render();
};

el8.apphome.docMgr.Filer.prototype._bindFormTriggers = function() {
    var that = this;

    //Both filer forms
    this._container.on('click', '.minimize-form-trigger',  function(e) {
        $('#filer-both-form-wrapper', that._container).hide();
        var title = $(this).parent().find('h4 span').text();
        $('#filer-form-content', that._container).append(
            el8.template.render.docMgr.filer.minimizedForm({title: title})
        );
    });
    this._container.on('click', '.maximize-form-trigger',  function(e) {
        $(this).remove();
        $('#filer-both-form-wrapper', that._container).show();
    });

    //Main filer form ("Assign & File")
    this._container.on('click', '.new-patient-trigger',  function(e) {
        el8.appshared.dialog.createPatient.show({
            name: that._form.getVal('patientName'),
            saveCallbackFn: function(data) {
                that._createNewPatientFn(data);
            }
        });
        return false;
    });
    this._container.on('click', '.quickadd-labs-trigger',  function() {
        $('#filer-form', that._container).hide();
        $('#filer-quickadd-form-wrapper', that._container).show();
        $('#filer-lab-form-wrapper', that._container).hide();
    });
    this._container.on('click', '.add-discrete-labs-trigger',  function() {
        $('#filer-form', that._container).hide();
        $('#filer-quickadd-form-wrapper', that._container).hide();
        $('#filer-lab-form-wrapper', that._container).show();
    });
    this._container.on('click', '.add-discrete-labs-from-quick-add-trigger',  function() {
        $('#filer-form', that._container).hide();
        $('#filer-quickadd-form-wrapper', that._container).hide();
        $('#filer-lab-form-wrapper', that._container).show();
    });
    el8.app.shared.dialog.filerFields.addDocumentTypeListener(this._container,
                                                              function() { return that._form; },
                                                              function() { return that._patient; });

    this._container.on('click', '.filer-hide-quickadd-form',  function() {
        $('#filer-form', that._container).show();
        $('#filer-quickadd-form-wrapper', that._container).hide();
        $('#filer-lab-form-wrapper', that._container).hide();
        that._updateLabValueSummary();
    });
    //Discrete labs form ("Add Lab Values")
    this._container.on('click', '.filer-hide-lab-form',  function() {
            //if there is an un-added lab, try to add; if we fail, don't leave this form
        if (el8.appshared.dialog.discreteLabFields.processTestForm() === false) { return; }

        var $addLabTrigger = $('.add-discrete-labs-trigger', that._container);
        if (el8.appshared.dialog.discreteLabFields.hasLabValues()) {
            //text indicator for whether or not there are labValues to submit
            $addLabTrigger.text('+ Add More Lab Values');
        } else {
            $addLabTrigger.text('+ Add Lab Values');
        }
        $('#filer-form', that._container).hide();
        $('#filer-quickadd-form-wrapper', that._container).show();
        $('#filer-lab-form-wrapper', that._container).hide();
        that._updateLabValueSummary();
    });

    /* el8.appshared.dialog.discreteLabFields.init binds other triggers after
        this._labForm is defined in initAssignmentForm */
};

el8.apphome.docMgr.Filer.prototype._fileIntoChart = function() {
    var that = this;
    if (!this._form.isValid()) { return; }
    this._form.disable();
    this._labForm.disable();
    var map = this._form.getMapped(true, true);
    var reviewUserItem = this._form.getMindreaderItem('physicianUserName');
    map['review_user_id'] = reviewUserItem ? reviewUserItem.id : null;
    delete map['physician_user_name'];

    map['file_ids'] = this._getFileIds();

    // Support grabbing the document date
    var documentDate = el8.service.tz.newTzDate(map['document_date']);

    // Save at 00:00:00 time, unless we're today.
    map['document_date'] = el8.service.tz.asServerFormatDateTime(el8.service.tz.zeroTimeIfNotToday(documentDate));

    // Add lab values if applicable
    if (this._form.getVal('documentType').toLowerCase() === 'labreport') {
        if (el8.appshared.dialog.discreteLabFields.hasLabValues()) {
            //no deleted labs in Filer (because there are never existing grids)
            map['lab_values'] = el8.appshared.dialog.discreteLabFields.labValuesForServer().labValues;
        }

        // grabbing the new ecqm doc gap fields
        var $content = $('#filer-form-content', this._container);
        var $labValueFieldInputs = $('.lab-value-field-entry', $content);

        $labValueFieldInputs.each( function($index, $input) {
            $input = $($input);
            var val = $.trim($input.val());
            if (val === '') { return; }

            // lookup labtest id, then use that to lookup local cache of lab attributes
            var labtestId = $input.attr('data-labtest-id');

            if (that._labtests.hasOwnProperty(labtestId)) {
                var labtestData = that._labtests[labtestId];
                var obj = $.extend({}, labtestData);
                obj['result_id'] = null;
                obj['value'] = val;

                if (!map['lab_values']) {
                    map['lab_values'] = [];
                }
                map['lab_values'].push(obj);
            }
        });
    }

    var selectedPatient = this._form.getMindreaderItem('patientName');
    this._patient = selectedPatient;

    if (!selectedPatient) {
        el8.appshared.dialog.createPatient.show({
            name: this._form.getVal('patientName'),
            saveCallbackFn: function(data) {
                var patientId = data['id'];
                that._doFile(patientId, map);
            },
            alertMsg: 'Patient chart was not found. Please create a new patient chart and document will be filed in this new chart.',
            saveButtonCaption: 'Create Chart & File Document'
        });
    } else {
        this._doFile(selectedPatient.id, map);
    }
};

el8.apphome.docMgr.Filer.prototype._doFile = function(patientId, map) {
    var that = this;
    var start = new Date();
    $.el8_ajax({
        type: 'POST',
        url: el8.service.urls.get('fileUnfiledDocuments', [patientId]),
        data: JSON.stringify(map),
        success: function(data) {
            var fileIds = map['file_ids'];
            that._resetForms();
            that._fileCallbackFn(fileIds);
            that._showOrganizerFn();

            el8.util.amplitude.logFileDocument('fax inbox', map, start);
            // Commenting out until we can get our mobile app to also add this
            // user property
            // el8.util.amplitude.addUserProperty('number of documents uploaded', 1);
        },
        error: function() {
            that._form.enable();
            that._labForm.enable();
        }
    });
};

el8.apphome.docMgr.Filer.prototype._resetLabValues = function() {
    el8.appshared.dialog.discreteLabFields.clearDialog();
    $('.add-discrete-labs-trigger', this._container).text('+ Add Lab Values');
};

el8.apphome.docMgr.Filer.prototype._resetForms = function() {
    this._patient = null;
    this._labtests = {};
    this._labtest_values = {};

    if (this._form) {
        this._form.reset();
        el8.app.shared.dialog.filerFields.resetVisibleFields(this._form);
        this._form.enable();
    }
    if (this._labForm) {
        this._labForm.reset();
        $('.add-discrete-labs-trigger', this._container).hide();
        $('.quickadd-labs-trigger', this._container).hide();
        this._labForm.enable();
        this._resetLabValues();
    }

    this._updateLabValueSummary();
    this._updateFormsForPatient(null);

    if (el8Globals.FEATURES.BiDiLabs) {
        $('.order-to-link-wrapper', this._container).hide();
    }
};

el8.apphome.docMgr.Filer.prototype._updateFormsForPatient = function(patient) {
    var that = this;

    if (!patient) {
        that._updatePanelLabValues([]);
        if (el8Globals.FEATURES.BiDiLabs) {
            el8.app.shared.dialog.filerFields.updateOutstandingOrders(null, null, null, that._container);
            $('.order-to-link-wrapper', that._container).hide();
        }
        return;
    } else {
        if (el8Globals.FEATURES.BiDiLabs) {
            // Reset the outstanding orders dropdown, remove type filter, reset docType
            el8.app.shared.dialog.filerFields.updateOutstandingOrders(patient, null, null, that._container);

            var $selected = $(':input[name="documentType"] option[selected]', that._container);
            if ($selected) { $selected.prop('selected', false); }

            var $docTypeOption = $(':input[name="documentType"] option', that._container).first();
            if ($docTypeOption) { $docTypeOption.prop('selected', true); }

            $('.order-to-link-wrapper', that._container).hide();
        }
    }

    $.el8_ajax({
        type: 'GET',
        async: false,
        url: '/patient/'+patient.id+'/reports/panels/',
        success: function(data) {
            if (data && data['panels']) {
                that._updatePanelLabValues(data['panels']);
            }
            else {
                that._updatePanelLabValues([]);
            }
        },
        error_override: function() {
            that._updatePanelLabValues([]);
        }
    });
};

// updates display on the main panel based on # of lab values entered
el8.apphome.docMgr.Filer.prototype._updateLabValueSummary = function() {
    var that = this;

    var lab_count = 0;

    if (el8.appshared.dialog.discreteLabFields.hasLabValues()) {
        lab_count += el8.appshared.dialog.discreteLabFields.labValuesForServer().labValues.length;
    }

    if (that._labtest_values) {
        lab_count += Object.keys(that._labtest_values).length;
    }

    if (lab_count === 0) {
        $(".lab-value-summary").addClass('hidden');
        $(".lab-value-summary").text('');
        $(".quickadd-labs-trigger").text('+ Add lab Values');
    }
    else {
        $(".lab-value-summary").removeClass('hidden');
        $(".quickadd-labs-trigger").text('+ Edit lab Values');

        if (lab_count > 1) {
            $(".lab-value-summary").text(lab_count + ' lab values entered.');
        }
        else {
            $(".lab-value-summary").text(lab_count + ' lab value entered.');
        }
    }
};

el8.apphome.docMgr.Filer.prototype._updatePanelLabValues = function(panels) {
    var that = this;

    var $container = $("#panel-lab-values-content");
    $container.html('');

    that._labtests = {}; // maintains a list of labs + values
    that._labtest_values = {}; // maintains a list of lab values entered

    panels.forEach(function (panel, index) {
        var a = el8.template.appshared.dialog.addDiscreteLabValues.labPanelSection({
            labtestcategoryId: panel.labtestcategory_id,
            vendorId: panel.vendor_id,
            description: panel.description,
            tests: panel.tests
        });
        $container.append(a);

        panel.tests.forEach(function(test) {
            that._labtests[test.labtest_id] = test;
            that._labtests[test.labtest_id]['labtestcategory_id'] = panel.labtestcategory_id;
            that._labtests[test.labtest_id]['vendor_id'] = panel.vendor_id;
        });
    });

    $container.on('blur', '.lab-value-field-entry',  function(e) {
        var $input = $(e.currentTarget);
        var value = $input.val();
        var id = $input.attr('data-labtest-id');

        if (!value) {
            delete that._labtest_values[id];
        }
        else {
            that._labtest_values[id] = value;
        }
        that._updateLabValueSummary();
    });

    $container.on('keyup', '.lab-value-field-entry',  function(e) {
        var $input = $(e.currentTarget);
        var value = parseFloat($input.val());
        var labtestId = $input.attr('data-labtest-id');

        var isAbnormal = false;
        if (that._labtests.hasOwnProperty(labtestId)) {
            var labtestData = that._labtests[labtestId];
            var min = labtestData['ref_min'];
            var max = labtestData['ref_max'];

            if (min !== null) {
                if (value < min) {
                    isAbnormal = true;
                }
            }
            if (max !== null) {
                if (value > max) {
                    isAbnormal = true;
                }
            }
        }

        if (isAbnormal) {
            $input.addClass('el8AttentionText el8Bold');
        }
        else {
            $input.removeClass('el8AttentionText el8Bold');
        }
    });

    // adding tooltip for each of the lab value entry
    $container.find('.lab-value-field-entry').each( function() {

        var $this = $(this);
        var labtestId = $this.attr('data-labtest-id');

        var msg = 'Ref Range: ';
        if (that._labtests.hasOwnProperty(labtestId)) {
            var labtestData = that._labtests[labtestId];
            var min = labtestData['ref_min'];
            var max = labtestData['ref_max'];

            if (min !== '' && min !== null) {
                if (max !== '' && max !== null) {
                    msg += min + " - " + max;
                }
                else {
                    msg += "> " + min;
                }
            }
            else {
                if (max !== '' && max !== null) {
                    msg += "< " + max;
                }
                else {
                    msg += "Not Specified";
                }
            }
        }

        el8.service.tooltip.create({
            anchor: $this,
            text: msg
        });
    });

    panels.forEach(function (panel, index) {
        var panelSelector = "#add-panel-lab-value-" + panel.labtestcategory_id;

        el8.uiwidget.collapsible({
            container: $(panelSelector+'-section', $container),
            triggerElt: $(panelSelector+'-trigger', $container),
            statusElt: $(panelSelector+'-status', $container),
            expandFn: function() {},
            collapseFn: function() {}
        });

        $(panelSelector+'-trigger', $container).trigger('click');
    });
};

el8.apphome.docMgr.Filer.prototype._showUnknownPatient = function() {
    $('.notify-unknown-patient', this._container).show();
};

el8.apphome.docMgr.Filer.prototype._hideUnknownPatient = function() {
    $('.notify-unknown-patient', this._container).hide();
};

el8.apphome.docMgr.Filer.prototype._createNewPatientFn = function(data) {
    var patient = el8.ptdata.patients.create(data);
    var map = patient.asAutocompleteMap();
    this._form.setMindreaderItem('patientName', map);
};
